import { useTranslation } from "react-i18next";
import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail, AlertCircle } from "lucide-react";

interface NoEmailErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  customerName: string;
}

export const NoEmailErrorDialog: React.FC<NoEmailErrorDialogProps> = ({
  open,
  onOpenChange,
  customerName,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-600" />
            {t("components.noEmailErrorDialog.cannotSendQuoteFor")}
          </DialogTitle>
          <DialogDescription className="space-y-3 pt-2">
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border border-red-200">
              <Mail className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
              <div className="space-y-2">
                <p className="text-sm font-medium text-red-900">
                  {t("components.noEmailErrorDialog.thisQuoteCannotBe")}
                </p>
                <div className="space-y-1 text-sm text-red-800">
                  <p>
                    <strong>{t("components.noEmailErrorDialog.customer")}</strong> {customerName}
                  </p>
                  <p className="mt-2">
                    {t("components.noEmailErrorDialog.pleaseAddAnEmail")}
                  </p>
                </div>
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
